import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { MENU_MODULES } from "src/constants/modules";
import Layout from "src/layout";
import LandingPage from "../Modules/MainMenu/Pages/LandingPage/LandingPage";
import { RootState } from "src/store";
import { setClientId, setSelectedMenu } from "src/store/slices/client";

export default function RouteGuard() {
  const token = useSelector((state: RootState) => state.auth.token);
  const menuItems = useSelector((state: RootState) => state.client.menuItems);
  const clientId = useSelector((state:RootState)=>state.client.selectedClientId);
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  if (!token) {
    if (pathname.startsWith("/login")) return <Outlet />;
    return <Navigate to="login" />;
  }

  if (pathname.startsWith("/login")) return <Navigate to="/" replace />;
  
  if(!clientId) return null;

  const matches = MENU_MODULES.filter((m) => pathname.includes(m.route));
  if (matches.length === 1) {
    const [match] = matches;
    const menuItem = menuItems.find((item) => item.type === match.type);
    if (menuItem) {
      dispatch(setSelectedMenu(menuItem.type));
      if (!match.isstatic) dispatch(setClientId(menuItem.clientId));
    }
  } else if (matches.length > 1) {
    const nonStatic = matches.find((m) => !m.isstatic);
    const menuItem = menuItems.find((item) => item.type === nonStatic?.type);
    if (menuItem) dispatch(setClientId(menuItem.clientId));
  }

  if (pathname === "/") return <LandingPage />;

  return <Layout />;
}
